import { SiteHeader } from './SiteHeader';

// Per-site wrapper: only the tag differs. Header logic lives in the shared
// project/shared/SiteHeader.tsx (synced here by scripts/gen-tokens.mjs).
export function Header() {
  return <SiteHeader tag="/favicongen" />;
}
